module.exports = __webpack_public_path__ + "img/Call-white.7b3ccc2a.svg";